import { ActionTypes } from '../actions';

const INITIAL_STATE = {
  buckets: {},
};

const FavoritesReducer = (state = INITIAL_STATE, action) => { // changes state value by 1
  switch (action.type) {
    case ActionTypes.UPDATE_FAVORITED_RESULTS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default FavoritesReducer;
